import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import EnvBanner from './components/EnvBanner'

const Login = lazy(() => import('./pages/Login'))
const Questionnaire = lazy(() => import('./pages/Questionnaire'))
const Results = lazy(() => import('./pages/Results'))
const SharedRecommendation = lazy(() => import('./pages/SharedRecommendation'))
const SharedQuote = lazy(() => import('./pages/SharedQuote'))
const PortalLayout = lazy(() => import('./components/PortalLayout'))
const Dashboard = lazy(() => import('./pages/ordering/Dashboard'))
const FarmerList = lazy(() => import('./pages/ordering/FarmerList'))
const FarmerView = lazy(() => import('./pages/ordering/FarmerView'))
const DryFertility = lazy(() => import('./pages/DryFertility'))
const ConsultantList = lazy(() => import('./pages/ordering/ConsultantList'))
const ConsultantView = lazy(() => import('./pages/ordering/ConsultantView'))
const QuoteList = lazy(() => import('./pages/ordering/QuoteList'))
const QuoteCreate = lazy(() => import('./pages/ordering/QuoteCreate'))
const QuoteView = lazy(() => import('./pages/ordering/QuoteView'))
const OrderList = lazy(() => import('./pages/ordering/OrderList'))
const OrderCreate = lazy(() => import('./pages/ordering/OrderCreate'))
const OrderView = lazy(() => import('./pages/ordering/OrderView'))
const BulkTracker = lazy(() => import('./pages/ordering/BulkTracker'))
const OrderingProducts = lazy(() => import('./pages/ordering/OrderingProducts'))
const ProductView = lazy(() => import('./pages/ordering/ProductView'))
const Reports = lazy(() => import('./pages/ordering/Reports'))
const ConsultantProfile = lazy(() => import('./pages/ordering/ConsultantProfile'))
const UsersSecurity = lazy(() => import('./pages/ordering/UsersSecurity'))
const UserManage = lazy(() => import('./pages/ordering/UserManage'))
const AdminData = lazy(() => import('./pages/ordering/AdminData'))
const RecommendationList = lazy(() => import('./pages/ordering/RecommendationList'))
const RecommendationDetail = lazy(() => import('./pages/ordering/RecommendationDetail'))
const Settings = lazy(() => import('./pages/ordering/Settings'))
const HelpLayout = lazy(() => import('./pages/help/HelpLayout'))
const HelpIndex = lazy(() => import('./pages/help/HelpIndex'))
const HelpDoc = lazy(() => import('./pages/help/HelpDoc'))

function App() {
  return (
    <div className="min-h-dvh bg-white">
      <EnvBanner />
      <Suspense fallback={null}>
        <Routes>
          {/* Root redirects to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />

          {/* Public read-only recommendation view — for sharing with farmers */}
          <Route path="/r/:sessionId" element={<SharedRecommendation />} />
          <Route path="/q/:quoteId" element={<SharedQuote />} />

          {/* Public help center — shareable URLs, no login required */}
          <Route path="/help" element={<HelpLayout />}>
            <Route index element={<HelpIndex />} />
            <Route path=":slug" element={<HelpDoc />} />
          </Route>

          {/* Portal routes (auth + sidebar via PortalLayout) */}
          <Route path="/portal" element={<PortalLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="questionnaire" element={<Questionnaire />} />
            <Route path="questionnaire/:sessionId" element={<Questionnaire />} />
            <Route path="results/:sessionId" element={<Results />} />
            <Route path="recommendations" element={<RecommendationList />} />
            <Route path="recommendations/:sessionId" element={<RecommendationDetail />} />
            <Route path="farmers" element={<FarmerList />} />
            <Route path="farmers/new" element={<FarmerView />} />
            <Route path="farmers/:farmerId" element={<FarmerView />} />
            <Route path="farmers/:farmerId/dry-fertility" element={<DryFertility />} />
            <Route path="consultants" element={<ConsultantList />} />
            <Route path="consultants/new" element={<ConsultantView />} />
            <Route path="consultants/:consultantId" element={<ConsultantView />} />
            <Route path="quotes" element={<QuoteList />} />
            <Route path="quotes/create" element={<QuoteCreate />} />
            <Route path="quotes/:quoteId" element={<QuoteView />} />
            <Route path="orders" element={<OrderList />} />
            <Route path="orders/new" element={<OrderCreate />} />
            <Route path="orders/bulk" element={<BulkTracker />} />
            <Route path="orders/:orderId" element={<OrderView />} />
            <Route path="products" element={<OrderingProducts />} />
            <Route path="products/:productId" element={<ProductView />} />
            <Route path="reports" element={<Reports />} />
            <Route path="profile" element={<ConsultantProfile />} />
            <Route path="users" element={<UsersSecurity />} />
            <Route path="users/:userId" element={<UserManage />} />
            <Route path="admin" element={<AdminData />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  )
}

export default App
